import { useMutation } from '@tanstack/react-query';
import useAuth from '../../hooks/useAuth.ts';
import { apiFetch } from '../../utils/apiUtils.ts';

interface RunRequestBody {
  message: string;
  campaign_version: number;
  iteration_version: number;
}

export interface RunRequestVariables {
  teamId: string;
  iterationId: string;
  campaignId: string;
  isDryRun?: boolean;
}

export default function useRunRequest() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId,
      iterationId,
      campaignId,
      isDryRun,
    }: RunRequestVariables) => apiFetch<RunRequestBody>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/runRequest`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: { runType: isDryRun ? 'dry run' : 'live run' },
    }),
  });
}
